<template>
  <!-- 内容组件，顶部左侧右侧 -->
  <div>
    <el-container style="border-bottom: 4px solid #eaeaea;">
      <el-header style="height: 8vh" class="Layout-header">
        <div :class="[NavShow ? 'Layout-Nav-Con-Show' : 'Layout-Nav-Con']" >
          <!-- <img v-if="this.Logo ==" :src="this.Logo" :class="[NavShow ? 'Layout-Nav-Logo-Show' : 'Layout-Nav-Logo']" /> -->
          <!-- <img v-else src="@/assets/logo.png" :class="[NavShow ? 'Layout-Nav-Logo-Show' : 'Layout-Nav-Logo']" /> -->
           <div v-if="!this.Logo" class="Layout-Nav-Logo-Show">
           </div>
          <img v-else :src="this.Logo" :class="[NavShow ? 'Layout-Nav-Logo-Show' : 'Layout-Nav-Logo']" />
          <i class="icon-menu but" @click="ShowNav"></i>
        </div>
        <!-- <div style="height:10vh;">
        </div> -->
        <admin-navbar @getcopyRight="getcopyRight" websiteType="deviceManagement"></admin-navbar>
      </el-header>
    </el-container>
    <el-container>
      <el-aside :style="{ 'width': NavShow ? '64px' : '220px' }" class="Layout-aside">
        <admin-nav></admin-nav>
      </el-aside>
      <el-container>
        <el-main class="Layout-main">
          <affix websiteType="deviceManagement"></affix>
          <admin-conlist></admin-conlist>
        </el-main>
        <el-footer style="display: flex;justify-content: center;align-items: center;">
          <div class="copyright">
            <p v-if="!copyRight">
              <span v-if="!Logo">
                Copyright @ 2019-{{ new Date().getFullYear() }} SZCHILINK. All Rights Reserved 深圳市智联物联科技有限公司 版权所有
              </span>
              <a href="https://beian.miit.gov.cn/" v-if="!Logo">粤ICP备16125435号</a>
            </p>
            <p v-else>
              <span v-if="!Logo">
                {{ copyRight.substring(0, copyRight.lastIndexOf(' ')) }}
              </span>
              <a href="https://beian.miit.gov.cn/">{{ copyRight.substring(copyRight.lastIndexOf(' ') + 1) }}</a>
            </p>
          </div>
          <a href="https://xyt.xcc.cn/getpcInfo?sn=1537335439185117184&language=CN&certType=8&url=*.singleyun.com"
            v-if="$i18n.locale == 'zh-CN' && !Logo" target="_blank"
            style="position: relative;display: inline-block;height: 38px;margin-left: 10px;">
            <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div>
            <embed src="https://program.xinchacha.com/web/1537335439185117184=*.singleyun.com.svg" width="103"
              height="38" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/" />
          </a>
          <a v-else-if="!Logo"
            href="https://xyt.xcc.cn/getpcInfo?sn=1537335439185117184&language=EN&certType=8&url=*.singleyun.com"
            target="_blank" style="position: relative;display: inline-block;height: 38px;margin-left: 10px;">
            <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div><embed
              src="https://program.xinchacha.com/web/1537335439185117184=*.singleyun.comen.svg" width="103" height="38"
              type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/" />
          </a>
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import AdminNav from './nav'
import AdminNavbar from './navbar'
import AdminConlist from './conlist'
import AdminBmmap from './bmmap'
import affix from './affix'
import { mapGetters, mapActions } from 'vuex'
export default {
  data() {
    return {
      copyRight: ''
    }
  },
  components: {
    AdminNav,
    AdminNavbar,
    AdminConlist,
    AdminBmmap,
    affix,
  },
  computed: {
    ...mapGetters(['NavShow', 'Logo']),
  },
  methods: {
    ...mapActions(['ShowNav']),
    getcopyRight(e) {
      this.copyRight = e || ''
    }
  },
}
</script>

<style scoped>
.Layout-header {
  /* border-bottom:4px solid  #eaeaea; */
  border-bottom: none;
  height: 8vh;
  background-color: #0074c7;
  width: 100%;
  display: flex;
}

.Layout-Nav-Con {
  width: 220px;
  height: 8vh;
  /* border-bottom:4px solid  #eaeaea; */
  border-bottom: none;
  box-sizing: border-box;
  z-index: 10;
  background-color: #0074c7;
  display: flex;
}

.Layout-Nav-Con-Show {
  width: 64px;
  height: 8vh;
  display: flex;
  /* border-bottom:4px solid  #eaeaea; */
  border-bottom: none;
  box-sizing: border-box;
  z-index: 10;
  background-color: #0074c7;
}

.Layout-Nav-Logo {
  width: 70%;
  margin: 0 auto 0 auto;
  display: block;
  height: 85%;
  padding-top: 2.5%;
  padding-bottom: 2.5%;
}

.Layout-Nav-Logo-Show {
  width: 70%;
  margin: 0 auto 0 auto;
  display: block;
  height: 85%;
  padding-top: 2.5%;
  padding-bottom: 2.5%;
}

.but {
  font-size: 20px;
  line-height: 10vh;
  color: #ffffff;
}

.copyright {
  text-align: center;
  line-height: 60px;
  font-size: 14px;
  color: #585757;
}

.Layout-main {
  background-color: #f0f2f5;
}

.Layout-aside {
  background-color: #0074c7;
}

/* .Layout-header{
    width: 100%;
    border-bottom:4px solid  #eaeaea;
}
.Layout-main{
    height: 85vh;
    width: 100%;
    background-color: #f0f2f5;
}
  .el-header{
    background-color: #0074c7;
  }
  .Layout-aside{
    background-color: #0074c7;
  }
  .el-aside{
  }
  .el-main{
    height: 89vh;
    width: 100%;
  }
.copyright{
  text-align: center;
  line-height: 60px;
  font-size: 14px;
  color: #585757;
} */
</style>
